import React, {Fragment, useEffect, useState} from 'react';
import './Login.scss';
import {Alert, Button, ButtonType, Card, Colors, InputField} from '../components';
import {isValidEmail} from '../utilities';
import auth, {hasValidRefresh} from '../api/auth';
import logo from '../assets/hotsauce-logo.svg';
import {APP_VERSION} from '../config';
import {useAppStore} from "../data/AppStore";
import {useNavigate} from "react-router-dom";

const Login = (props) => {
    const [state, _setState] = useState({
        customer: null,
        email: null,
        password: null,
        unauthorized: false,
        reset: false,
        loading: false,
        missing: false,
        done: false,
        payment: false
    });
    const setState = (newState) => _setState(Object.assign({}, state, newState));
    const {email, password, customer, unauthorized, loading, reset, missing, done, payment} = state;
    const navigate = useNavigate();
    const setUser = useAppStore.getState().setUSER;

    useEffect(() => {
        redirectIfLoggedIn();
    }, [])

    const redirectIfLoggedIn = () => {
        if (hasValidRefresh()) {
            navigate('/home', {replace: true});
        }
    }


    const handleSubmitClick = () => {
        loginUser();
    }

    const handleInputKeyPress = (e) => {
        if (e.which === 13 && isValid()) {
            loginUser();
        }
    }

    const isValid = () => {
        return customer && isValidEmail(email) && (reset || password);
    }

    const handleAlertCloseClick = () => {
        setState({unauthorized: false, payment: false});
    }

    const loginUser = async () => {
        try {

            const data = {
                customer,
                email,
                password
            };

            setState({loading: true, unauthorized: false});

            if (reset) {
                await auth.reset(data);
                setState({loading: false, done: true});
            } else {
                await auth.login(data);
                setUser({customer, email});
                navigate('/home', {replace: true});
            }
        } catch (error) {
            if (error.response && error.response.status === 402) {
                setState({loading: false, payment: true});
            } else if (error.response && error.response.status === 401) {
                setState({loading: false, unauthorized: true});
            } else if (error.response && error.response.status === 404) {
                setState({loading: false, missing: true});
            } else {
                setState({loading: false});
            }
        }
    }

    const build = () => {

        if (reset && done) {
            return (
                <div className='login-wrapper'>
                    <Alert
                        success
                        message={'An email has been sent to you, please check your inbox and follow the link.'}
                        onCloseClick={() => {
                            navigate('/', {replace: true});
                        }}
                    />
                </div>
            );
        }

        if (reset) {
            return (
                <div className='login-wrapper'>
                    <p>Enter your company id and email to get a password reset email link.</p>
                    <div>
                        {missing && (
                            <Alert
                                failure
                                message={'Unable to find a user with that information.'}
                                onCloseClick={() => {
                                    navigate('/home', {replace: true});
                                }}
                            />
                        )}
                        <InputField
                            placeholder={'Company Id'}
                            className={'vertical-layout'}
                            onChange={(e) => {
                                setState({customer: e.toLowerCase()});
                            }}
                            onKeyPress={handleInputKeyPress}
                            value={customer}
                        />
                        <InputField
                            placeholder={'Email'}
                            className={'vertical-layout'}
                            onChange={(e) => {
                                setState({email: e.toLowerCase()});
                            }}
                            onKeyPress={handleInputKeyPress}
                            value={email}
                            email
                        />
                        <span>
              <Button
                  label={'Login'}
                  onClick={() => {
                      setState({reset: false});
                  }}
              />
              <Button
                  label={'Continue'}
                  disabled={!isValid() || loading}
                  onClick={handleSubmitClick}
              />
            </span>
                    </div>
                </div>
            );
        }

        return (
            <Fragment>
                {unauthorized && (
                    <Alert
                        failure
                        message={'Authentication failed. Please check your email and password.'}
                        onCloseClick={handleAlertCloseClick}
                    />
                )}
                {payment && (
                    <Alert
                        failure
                        message={'Subscription has expired or is invalid.'}
                        onCloseClick={handleAlertCloseClick}
                    />
                )}
                <form className='login-wrapper'>
                    <p className={'Label'}>Fill in your information below to login</p>
                    <InputField
                        label={'Company Id'}
                        placeholder={'ACME'}
                        className={'vertical-layout'}
                        onChange={(e) => {
                            setState({customer: e.toLowerCase()});
                        }}
                        onClearIconClick={() => setState({customer: ''})}

                        onKeyPress={handleInputKeyPress}
                        value={customer}
                    />
                    <InputField
                        label={'Email'}
                        placeholder={'user@acme.com'}
                        className={'vertical-layout'}
                        onChange={(e) => {
                            setState({email: e.toLowerCase()});
                        }}
                        onClearIconClick={() => setState({email: ''})}

                        onKeyPress={handleInputKeyPress}
                        value={email}
                        email="true"
                    />
                    <InputField
                        label={'Password'}
                        className={'vertical-layout'}
                        onChange={(e) => {
                            setState({password: e});
                        }}
                        onClearIconClick={() => setState({password: ''})}
                        onKeyPress={handleInputKeyPress}
                        placeholder={'1234567890'}
                        value={password}
                        type={'password'}
                    />
                    <span>
              <Button
                  label={'Reset Password'}
                  type={ButtonType.Reset}
                  onClick={() => {
                      setState({reset: true});
                  }}
              />
              <Button
                  form={true}
                  label={'Continue'}
                  type={ButtonType.Forward}
                  colorTheme={Colors.Orange}
                  disabled={!isValid() || loading}
                  onClick={handleSubmitClick}
              />
            </span>
                </form>
            </Fragment>

        );
    }

    return (
        <div className={'Login'}>
            <img src={logo} alt={'Hotsauce Logo'} className={'hotsauce-logo'}/>
            <Card colorTheme={Colors.Orange}>
                {build()}
                <p onClick={() => {
                    // hack here
                }}>v{APP_VERSION}</p>
            </Card>
        </div>
    );
}

export default Login;

